import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {Observable} from 'rxjs';

import {Data, Listing} from '../../../../core/models/listing';
import {Globals} from '../../../../core/services/globals';
import {ListingsService} from "../../../../core/services/listings-service.interface";

@Injectable()
export class PeelHaltonListingsService implements ListingsService {
  private listingsUrlStr = 'https://listings.caymanmarshalladmin.com/api/v1/listings'; // URL to web api

  constructor(
    private http: HttpClient,
    private globals: Globals,
  ) {
  }

  getListings(): Observable<Data> {
    // console.log(this.globals);
    const paramsObj = this.getFilterPostObj();
    const params = new HttpParams({
      fromObject: paramsObj,
    });

    const httpOptions = {
      params: params,
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Bearer ' + environment.apiKey
      }),
    };
    return this.http.get<Data>(
      this.listingsUrlStr,
      httpOptions,
    );

  }

  getListing(MLSNum: string): Observable<Data> {
    // define properties
    const urlStr = this.listingsUrlStr;
    const paramsObj = this.getDetailsPostObj(MLSNum);
    const params = new HttpParams({
      fromObject: paramsObj,
    });

    const httpOptions = {
      params: params,
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Bearer ' + environment.apiKey
      }),
    };
    return this.http.get<Data>(
      urlStr,
      httpOptions,
    );
  }

  loadMore() {
    // set the global limit num
    this.globals.startNum += 10;
    this.globals.endNum += 10;
    this.globals.page += 1;
    const paramsObj = this.getFilterPostObj();
    const params = new HttpParams({
      fromObject: paramsObj,
    });

    const httpOptions = {
      params: params,
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Bearer ' + environment.apiKey
      }),
    };
    return this.http.get<Listing[]>(
      this.listingsUrlStr,
      httpOptions,
    );
  }

  filterListings(searchObj: object): any {
    // console.log(this.globals);
    const paramsObj = this.getFilterPostObj();
    const params = new HttpParams({
      fromObject: paramsObj,
    });

    const httpOptions = {
      params: params,
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Bearer ' + environment.apiKey
      }),
    };
    return this.http.get<Listing[]>(
      this.listingsUrlStr,
      httpOptions,
    );
  }

  private getFilterPostObj() {
    //console.log('filter post object generating');
    // define properties
    const startNum = this.globals.startNum;
    const endNum = this.globals.endNum;
    const indexNum = endNum + 1;
    const idStr = this.globals.idStr;
    const statusStr = 'Active,Sold';
    const orderStr = 'desc';
    const propertyTypeStr = this.globals.propertyTypeStr;
    let districtList = this.globals.districtList;
    const searchMin = this.globals.searchMin;
    const searchMax = this.globals.searchMax;
    const bedroomsNum = this.globals.bedroomsNum;
    const bathroomsNum = this.globals.bathroomsNum;
    const squareFeetStr = this.globals.squareFeetStr;
    const savedSearchIDStr = this.globals.savedSearchIDStr;
    const userIDStr = this.globals.userIDStr;
    const enableExclusiveListingsBln = this.globals.enableExclusiveListingsBln;
    const includeMedia = true;
    const etobicokeArr = [
      'Etobicoke',
      'Long Branch',
      'Alderwood',
      'Mimico',
      'New Toronto',
      'Humber Bay Shores',
      'Stonegate-Queensway',
    ];
    if (districtList === 'Etobicoke') {
      districtList = etobicokeArr.join();
    }
    // generate the JSON Object property for posting to the server
    const JSONObj = {
      page: this.globals.page,
      start: startNum,
      endNum: endNum,
      indexNum: indexNum,
      idStr: idStr,
      sort: orderStr,
      'external[eq]': false,
      'private[eq]': false,
      'status[in]': statusStr,
      'propertyType[eq]': propertyTypeStr,
      'municipality[in]': '',
      'community[in]': '',
      'area[in]': '',
      'listingPrice[between]': searchMin + '-' + searchMax,
      'bedroomsTotal[gte]': '',
      'bathroomsTotal[gte]': '',
      'squareFeet[lt]': '',
      'squareFeet[gt]': '',
      'clientId': '',
      userIDStr: '',
      enableExclusiveListingsBln: enableExclusiveListingsBln,
      includeMedia: includeMedia
    };
    if (districtList !== '' && (districtList === 'Mississauga' || districtList === 'Burlington' || districtList === 'Oakville')) {
      delete (JSONObj as any)['community[in]'];
      JSONObj['municipality[in]'] = districtList;
    } else if (districtList !== '' && districtList === 'Toronto') {
      delete (JSONObj as any)['municipality[in]'];
      delete (JSONObj as any)['community[in]'];
      JSONObj['area[in]'] = districtList;
    } else if (districtList !== '' && districtList !== 'All Of Muskoka' && districtList !== 'Toronto') {
      delete (JSONObj as any)['municipality[in]'];
      JSONObj['community[in]'] = districtList;
    } else {
      delete (JSONObj as any)['community[in]'];
      delete (JSONObj as any)['municipality[in]'];
    }
    if (propertyTypeStr !== 'Not Specified') {
      JSONObj['propertyType[eq]'] = propertyTypeStr;
    } else {
      delete (JSONObj as any)['propertyType[eq]'];
    }
    if (bedroomsNum !== 'Any') {
      JSONObj['bedroomsTotal[gte]'] = bedroomsNum;
    } else {
      delete (JSONObj as any)['bedroomsTotal[gte]'];
    }
    if (bathroomsNum !== 'Any') {
      JSONObj['bathroomsTotal[gte]'] = bathroomsNum;
    } else {
      delete (JSONObj as any)['bathroomsTotal[gte]'];
    }
    if (squareFeetStr !== 'Any') {
      if (squareFeetStr === '1000-') {
        delete (JSONObj as any)['squareFeet[gt]'];
        JSONObj['squareFeet[lt]'] = '1000';
      } else {
        delete (JSONObj as any)['squareFeet[lt]'];
        switch (squareFeetStr) {
          case '1000+':
            JSONObj['squareFeet[gt]'] = '1000';
            break;
          default:
            JSONObj['squareFeet[gt]'] = squareFeetStr;
            break;
        }
      }
    } else {
      delete (JSONObj as any)['squareFeet[gt]'];
      delete (JSONObj as any)['squareFeet[lt]'];
    }
    if (savedSearchIDStr !== '') {
      JSONObj.clientId = savedSearchIDStr;
    } else {
      delete (JSONObj as any)['clientId'];
    }
    if (userIDStr !== '') {
      JSONObj.userIDStr = userIDStr;
    } else {
      delete (JSONObj as any)['userIDStr'];
    }
    //if (yearBuilt!='All') JSONObj.yearBuilt=yearBuilt;
    // console.log(JSONObj);
    // return the json object to send to as post data
    return JSONObj;
  }

  private getDetailsPostObj(MLSNum: string) {
    // define properties
    return {
      'MLSNUM[eq]': MLSNum,
      includeMedia: true
    };
  }
}
